import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcTextAreaInputComponent } from './fc-text-area-input.component';


@NgModule({
  declarations: [
    FcTextAreaInputComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PipesModule,
    ReactiveFormsModule,
  ],
  exports: [
    FcTextAreaInputComponent,
  ]
})
export class FcTextAreaInputModule {}
